// @flow
import createMaybeTransform from 'app/common/react/components/closeup/utils/createMaybeTransform';
import type { HasPin, MaybeAToMaybeAB } from 'app/common/react/components/closeup/utils/types';

type HasVisualObjects = {
  visualObjects: Array<Object>,
};

type ToMaybeHasPinTags = MaybeAToMaybeAB<HasPin, HasVisualObjects>;

const hasPinTags: ToMaybeHasPinTags = createMaybeTransform((props) => {
  const { pin } = props,
    { visual_objects: visualObjects } = pin;
  return visualObjects ? { ...props, visualObjects } : null;
});

export default hasPinTags;
